import { useNavigate } from "react-router-dom";
import { useToast } from "duck";
import {
  MedicalCasesDocument,
  useImportVetspireMedicalCaseMutation
} from "requests";
import { FormValues } from "./types";

export const useImportVetspireCase = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const [importVetspireCase] = useImportVetspireMedicalCaseMutation({
    ignoreResults: true
  });

  return (formValues: FormValues) =>
    importVetspireCase({
      variables: {
        input: {
          name: formValues.caseName,
          doctor: formValues.doctor,
          vetspirePatientId: formValues.patient,
          clientMutationId: formValues.client
        }
      },
      refetchQueries: [{ query: MedicalCasesDocument }]
    }).then(data => {
      navigate(
        `/cases/${data?.data?.importVetspireMedicalCase?.vetspireMedicalCase?.medicalCase._id}/check-in`
      );
      toast({
        status: "success",
        description: `Case ${formValues.caseName} is created successfully.`
      });
    });
};
